"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypesExtra = require("prop-types-extra");

require("./Image.css");

function Image(props) {
  var alt = props.alt,
      className = props.className,
      imgStyle = props.imgStyle,
      message = props.message,
      src = props.src,
      style = props.style,
      otherProps = (0, _objectWithoutProperties2["default"])(props, ["alt", "className", "imgStyle", "message", "src", "style"]);
  var classNames = (0, _classnames["default"])(['stx-image', className]);
  var styleValue = style || imgStyle;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classNames
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "stx-image--content"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "stx-image--holder"
  }, /*#__PURE__*/_react["default"].createElement("img", (0, _extends2["default"])({
    alt: alt,
    className: "stx-image--image",
    src: src,
    style: styleValue
  }, otherProps))), message && /*#__PURE__*/_react["default"].createElement("div", {
    className: "stx-image--message"
  }, message)));
}

Image.defaultProps = {
  /*
   * This property should be mandatory, since "alt" is an essential image attribute for accessibility.
   * However, making it required through PropTypes could impact existing code that is currently using Stacks UI.
   */
  alt: 'no-name-provided'
};
Image.propTypes = {
  alt: _propTypes["default"].string,
  className: _propTypes["default"].string,
  imgStyle: (0, _propTypesExtra.deprecated)(_propTypes["default"].object, 'Use the style prop instead'),
  message: _propTypes["default"].string,
  src: _propTypes["default"].string,
  style: _propTypes["default"].string
};
var _default = Image;
exports["default"] = _default;